import { Modal } from '@els/els-react--modal';
import { ELSIconV2 } from 'components/common';
import CourseSelectionModal from 'components/common/course-selection-modal/CourseSelectionModal';
import { REPORT_TITLE } from 'constants/app.constant';
import { renderNavItem } from './HADPageNavigatorModalHelper';
import useHADPageNavigatorModal from './useHADPageNavigatorModal';
require("assets/common/images/learning-competency.svg");
require("assets/common/images/learning-competency--disabled.svg");
require("assets/common/images/psychology.svg");
require("assets/common/images/psychology--disabled.svg");
require("assets/common/images/machine-learning--hover.svg");
require("assets/common/images/machine-learning--hover.svg");
require("assets/common/images/empowering-knowledge-c.svg");
require("assets/common/images/empowering-knowledge-c--disabled.svg");
var HADPageNavigatorModal = function (_a) {
    var handleCancel = _a.handleCancel, isHesiReadinessApp = _a.isHesiReadinessApp;
    var _b = useHADPageNavigatorModal({
        isHesiReadinessApp: isHesiReadinessApp
    }), courseSelectionModalProps = _b.courseSelectionModalProps, navItems = _b.navItems, showCourseSelectionModal = _b.showCourseSelectionModal;
    return (<>
      <Modal className="c-had-navigator-modal" label={REPORT_TITLE.HESI_NCLEX_READINESS.title} onClose={handleCancel} shouldHideCloseButton shouldCloseOnEscape={!showCourseSelectionModal}>
        <div className="c-had-navigator-modal__content">
          <div className="c-had-navigator-modal__content-row">
            {REPORT_TITLE.HESI_NCLEX_READINESS.title}
            <button tabIndex={0} type="button" className="u-cursor-pointer c-had-navigator-modal__content-row-close-btn" onClick={handleCancel} aria-label={"Close ".concat(REPORT_TITLE.HESI_NCLEX_READINESS.title)}>
              <ELSIconV2 sprite="Close" id="had-page-navigator-modal-close" size="m" isDecorative/>
            </button>
          </div>
          <div className="c-els-divider c-els-divider--1o2"/>
          <div className="u-els-color-secondary c-had-navigator-modal__content-row">Dashboard Home</div>
          <div className="c-els-divider c-els-divider--1o2"/>
          <div>
            <div className="c-had-navigator-modal__content-row">My Dashboards</div>
            <div className="c-had-navigator-modal__content-row c-had-navigator-modal__nav">{navItems.map(function (item) { return renderNavItem(item); })}</div>
          </div>
        </div>
      </Modal>
      {showCourseSelectionModal && <CourseSelectionModal {...courseSelectionModalProps}/>}
    </>);
};
export default HADPageNavigatorModal;
